import { render, staticRenderFns } from "./FormControlInsurance.vue?vue&type=template&id=5db5ea05&scoped=true"
import script from "./FormControlInsurance.vue?vue&type=script&lang=js"
export * from "./FormControlInsurance.vue?vue&type=script&lang=js"
import style0 from "./FormControlInsurance.vue?vue&type=style&index=0&id=5db5ea05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db5ea05",
  null
  
)

export default component.exports